import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { SQLitePorter} from '@awesome-cordova-plugins/sqlite-porter/ngx';
import { SQLite, DbTransaction, SQLiteObject } from '@awesome-cordova-plugins/sqlite/ngx';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

  private database: SQLiteObject;

  constructor(
    private plt: Platform,
    private readonly sqlitePorter: SQLitePorter,
    private sqlite: SQLite,
    private readonly http : HttpClient
  ) { 

    if(this.plt.is("capacitor")){
      
      this.plt.ready().then(
        async () => {
          try{
            this.sqlite.create({
              name: 'coach_companion.db',
              location: 'default'
            })
            .then(
              (db: SQLiteObject) => {
                this.database = db;
                this.createDatabase();
              }
            )
          }catch(err){
            console.error("Error creating database", err);
          }
        }
      )
    }

  }

  createDatabase() {
    this.http.get('assets/seed.sql', { responseType: 'text'})
    .subscribe(sql => {
      this.sqlitePorter.importSqlToDb(this.database, sql)
        .then(_ => {
          this.getBddVersion().then(
            async (version) => {
              if(version.user_version == 0){
                await this.getImportSeed("seed15121");
                await this.setBddVersion(1);
                version.user_version = 1;
              }
              if(version.user_version == 1){
                await this.getImportSeed("seed15142");
                await this.setBddVersion(2);
                version.user_version = 2;
              }
              if(version.user_version == 2){
                await this.getImportSeed("seed15167");
                await this.setBddVersion(3);
                version.user_version = 3;
              }
              if(version.user_version == 3){
                await this.getImportSeed("seed15173");
                await this.setBddVersion(4);
                version.user_version = 4;
              }
            },
            (err) => {
              console.error("Error getting database version", err);
            }
          );

        })
        .catch(e => console.error(e));
    });
  }

  deletePhoneInfo(){
    return new Promise(
      async (resolve, reject) => {
        if(this.plt.is("capacitor")){
          try{
            await this.waitDatabaseReady();
            this.database.transaction(
              (tx : DbTransaction) => {
                tx.executeSql(
                  'DELETE FROM DEVICE_INFO',
                  [],
                  (tx : DbTransaction, data : any) => {
                    resolve(true);
                  },
                  (tx : DbTransaction, data : any) => {
                    reject(false);
                  }
                )
              }
            )
          }catch(err){

          }
        }
      }
    )
  }

  public async getBddVersion() : Promise<any>{
    return new Promise(
      async (resolve, reject) => {
        await this.waitDatabaseReady();
        this.database.transaction(
          (tx: DbTransaction) => {
            tx.executeSql(
              'PRAGMA user_version',
              [],
              async (tx:any, data:any) => {
                resolve(data.rows.item(0));
              },
              (tx:any, data:any) => {
                reject(data);
              }
            )
          }
        )
      }
    )
  }

  public async waitDatabaseReady() {
    let i=0;
    while (this.database == null) {
      if (i>=10) {
        throw new Error('Impossible de charger la base de donnée locale / Impossible to load local database');
      }
      i++;
      await new Promise(resolve => setTimeout(resolve, 500));
    }
  }

  getImportSeed(seedName : string) : Promise<any>{
    return new Promise(
      async (resolve, reject) => {
        this.http.get('assets/' + seedName + '.sql', { responseType: 'text'}).subscribe({
          next : (sql) => {
             this.sqlitePorter.importSqlToDb(this.database, sql).then(
              (data) => {
                resolve(data);
              },
              (err) => {
                console.error("ImportSeed error");
              }
             )
          },
          error : (err) => {
            reject(err);
          }
        })
      }
    )
  }

  public async setBddVersion(version : number) : Promise<boolean>{
    return new Promise(
      async (resolve, reject) => {
        await this.waitDatabaseReady();
        this.database.transaction(
          (tx: DbTransaction) => {
            tx.executeSql(
              'PRAGMA user_version =' + version,
              [],
              async (tx:any, data:any) => {
                resolve(true);
              },
              (tx:any, data:any) => {
                reject(false);
              }
            )
          }
        )
      }
    )
  }

  // !! TO INSERT PLEASE USE insertPhoneInfo(date : string) !! 
  async addPhoneInfo(firebaseToken : string){
    if(this.plt.is("capacitor")){
      try{
        this.waitDatabaseReady();
        let data = [firebaseToken];
        await this.database.executeSql('INSERT INTO DEVICE_INFO (FIREBASE_TOKEN) VALUES (?)', data)
      }catch(err){
        console.error("Error adding phone info", err);
      }

    }
  }

  insertPhoneInfo(firebaseToken : string){
    try{
      this.deletePhoneInfo().then(
        (data) => {
          this.addPhoneInfo(firebaseToken);
        },
        (err) => {
          console.log(err);
        }
      )
    }catch(err){
      console.error("Error inserting phone info", err);
    }

  }

  getLocalFirebaseToken() : Promise<string> {
    return new Promise(
      async (resolve, reject) => {
        if(this.plt.is("capacitor")){
          try{
            await this.waitDatabaseReady();
            this.database.transaction(
              (tx : any) => {
                tx.executeSql(
                  'SELECT * FROM DEVICE_INFO LIMIT 1',
                  [],
                  (tx : any, data : any) => {
                    if(data && data.rows.item(0)){
                      resolve(data.rows.item(0).FIREBASE_TOKEN);
                    }
                    resolve('');
                  },
                  (tx : any, err : any) => {
                    reject(err);
                  }
                )
              }
            )
          }catch(err){
            reject(err);
          }

        }
      }
    )
  }

}
